import { useMutation } from '@tanstack/react-query'
import { putShowVerifiedBanner } from 'services/AccountService'

export const useShowVerifiedBannerMutation = () => {
  return useMutation({ mutationFn: putShowVerifiedBanner })
}
